import { UpsellOrderStatus } from 'uplisting-frontend/models/upsell-order';
import {
  FilterId,
  FilterOptionsType,
  SingleSelectFilter,
} from 'uplisting-frontend/utils/filters/abstract';

export class UpsellOrderStatusFilter extends SingleSelectFilter<void> {
  id = FilterId.upsellOrderStatus;
  optionsType = FilterOptionsType.list;
  optionsList = [
    UpsellOrderStatus.pending,
    UpsellOrderStatus.failed,
    UpsellOrderStatus.paid,
    UpsellOrderStatus.requested,
    UpsellOrderStatus.rejected,
    UpsellOrderStatus.fulfilled,
    UpsellOrderStatus.refunded,
  ];
}
